import { memo } from "react";
import propTypes from "prop-types";
import "./AccommodationSummaryList.scss";
import { FormattedMessage } from "react-intl";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import AccommodationSummary from "./AccommodationSummary";
import PassengersCounterDisplay from "app/pages/.shared/PassengersCounterDisplay";

const AccommodationSummaryList = ({ accommodations = [] }) => {
	const hasMultipleAccommodations = accommodations.length > 1;

	return (
		<ol className="accommodation-summary-list">
			{accommodations.map((accommodation, index) => {
				return (
					<li key={"accommodation-" + index + 1}>
						{hasMultipleAccommodations && (
							<Typography
								variant={TYPOGRAPHY_VARIANTS.REGULAR}
								isBold
								className="accommodation-summary-list__title"
								component="p"
							>
								<FormattedMessage
									id="accommodation.room.number"
									values={{ roomNumber: index + 1 }}
								/>{" "}
								(
								<PassengersCounterDisplay
									adults={accommodation?.distribution?.adults}
									children={accommodation?.distribution?.children}
									infants={accommodation?.distribution?.babies}
								/>
								):
							</Typography>
						)}

						<AccommodationSummary
							accommodationType={accommodation?.accommodationType}
							boardType={accommodation?.boardType}
							freeCancellationDeadline={accommodation?.freeCancellationDeadline}
							hasLeftDivider={hasMultipleAccommodations}
						/>
					</li>
				);
			})}
		</ol>
	);
};

AccommodationSummaryList.propTypes = {
	accommodations: propTypes.arrayOf(
		propTypes.shape({
			accommodationType: propTypes.string,
			boardType: propTypes.string,
			freeCancellationDeadline: propTypes.string,
			distribution: propTypes.object,
		})
	),
};

export default memo(AccommodationSummaryList);
